import React from "react";
import "../styles/loading.scss";
import logo from '../img/sp-load.svg'
interface LoadingProps {
	height?: number;
	show?: boolean;
}

export default function Loading({ height, show = false }: LoadingProps) {
	if (show === true) {
		return (
			<div className="loading-overlay" style={{ height: `${height ? height + "px" : "100%"}` }}>
				<img className="loading-spinner" src={logo} alt="" />
			</div>
		);
	} else {
		return null;
	}
}